import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import NextButton from "./components/NextButton";
import PrevButton from "./components/PrevButton";
import LoadMoreButton from "./components/LoadMoreButton";
import { checkIfMobile } from "../../util";

class HorizontalSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: checkIfMobile(),
    };
  }

  render() {
    const { loadMore, isLoading, hasMore, children } = this.props;

    const SliderSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <NextButton slidesToShow={this.state.isMobile ? 1 : 3} />,
      prevArrow: <PrevButton />,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
      ],
    };

    return (
      <Slider {...SliderSettings}>
        {children}
        {hasMore && <LoadMoreButton message="View More Cases" onClick={loadMore} isLoading={isLoading} />}
      </Slider>
    );
  }
}

export default HorizontalSlider;



// WEBPACK FOOTER //
// ./src/components/HorizontalSlider/index.js